import request from '@/plugins/axios'
import { deserializeObject } from "@/util/nativeHelper";

export async function pushRecords(records){
  const max_record = 300
  const results = []
  for (let i = 0; i < records.length; i+= max_record) {
    const slicedRecord = records.slice(i,i + max_record)
    if(!slicedRecord.length) continue
    const query = `
INSERT INTO record
(boksik,winners,losers,result,players,date)
VALUES ${
      slicedRecord.map(({boksik,winners,losers,result,players,date}) =>
        ('('+[boksik,winners,losers,result,players,date].map(item=>{
          const str = JSON.stringify(item)
          return typeof item === 'number' || typeof item === 'string' || typeof item === 'boolean' ? `${str}` : `'${str}'`
        }).join(',')+')')).join(',')
    }
`
    try{
      results.push(await request.post('/dbManager?pushRecords', {query}))
    }catch(e){
      results.push(e)
    }
  }
  return results
}
export function getRecords(){
  const query = 'SELECT * FROM record'
  return request.post('/dbManager?getRecords',{query}).then(({data}) => {
    return data.result.map(deserializeObject)
  })
}